import React, { lazy, Suspense, useLayoutEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";

import { Route, Routes, useLocation } from "react-router-dom";
import Loader from "./Loader";
import { Toaster } from "react-hot-toast";
import { ErrorBoundary } from "react-error-boundary";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreaters } from "../Redux";
import AdminListService from "../services/admin-list.service";
import $ from "jquery";

const UploadCategories = lazy(() =>
  import("./UploadCategories/UploadCategories")
);
const UpdateCategories = lazy(() =>
  import("./UploadCategories/UpdateCategories")
);
const Login = lazy(() => import("./Login/Login"));
const ForgotPassword = lazy(() => import("./Login/ForgotPassword"));
const ResetPassword = lazy(() => import("./Login/ResetPassword"));
const SiteForm = lazy(() => import("./SiteForm/SiteForm"));
const SitesListing = lazy(() => import("./SiteForm/SitesListing"));
const SiteCredentials = lazy(() =>
  import("./SiteForm/SiteCredentials/SiteCredentials")
);
const SiteFormSign = lazy(() => import("./SiteForm/SiteFormSign"));
const Home = lazy(() => import("./Home/home"));
const AddUsers = lazy(() => import("./Users/AddUsers"));
const EditUsers = lazy(() => import("./Users/EditUsers"));
const Profile = lazy(() => import("./Users/Profile"));

const ViewUsers = lazy(() => import("./Users/ViewUsers"));
const UploadFile = lazy(() => import("./UploadFile/UploadFile"));
const UpdateFile = lazy(() => import("./UploadFile/UpdateFile"));

const ViewFiles = lazy(() => import("./UploadFile/ViewFiles"));

const Sidebar = lazy(() => import("./Includes/SideCanvas/Sidebar"));

const NotFound = lazy(() => import("./NotFound"));

function ErrorFallback({ error, resetErrorBoundary }) {
  return (
    <div id="notfound">
      <div className="notfound">
        <div className="notfound-404">
          <h1>
            4<span>2</span>4
          </h1>
        </div>
        <h2>{error.message}</h2>
        <button
          className="btn btn-block btn-primary nm-btn"
          onClick={resetErrorBoundary}
        >
          Try again
        </button>
      </div>
    </div>
  );
}
export default function Roots() {
  const locat = useLocation();
  const { user } = useSelector((state) => state.stateVals);
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    if (window.scrollY > 500) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };
  const backToTop = () => {
    return (
      $("html, body").animate(
        {
          scrollTop: 0,
        },
        0
      ),
      !1
    );
  };

  const MoveToHome = () => {
    useLayoutEffect(() => {
      window.location.href = "/";

      // eslint-disable-next-line
    }, []);
    return <></>;
  };
  const dispatch = useDispatch();
  const userActions = bindActionCreators(actionCreaters, dispatch);
  useLayoutEffect(() => {
    if (user) {
      async function getCategoryByState() {
        try {
          //FIXME remove this service if not used
          const response = await AdminListService.getCategory(user.token);

          await userActions.logIn(response?.data?.data, "catStore");
        } catch (err) {}
      }
      getCategoryByState();
    }
    return () => {
      userActions.logIn([], "catStore");
    };
  }, []);
  const [isSidebarOpen, setIsSidebarOpen] = useState(
    window.innerWidth > 1199 ? false : true
  );
  useLayoutEffect(() => {
    backToTop();
    if (window.innerWidth < 1200) {
      setIsSidebarOpen(true);
    }
    const handleOutsideClick = (event) => {
      // Check if the click is outside the menu

      if (
        !$(event.target).closest(".menu-profile").length &&
        $(".menu-bottom").hasClass("open")
      ) {
        $(".menu-bottom").removeClass("open");
      }
    };

    window.addEventListener("scroll", toggleVisibility);

    $(document).on("mousedown", handleOutsideClick);
    return () => {
      $(document).off("mousedown", handleOutsideClick);
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, [locat.pathname]);
  return (
    <>
      <Toaster />
      <ErrorBoundary
        FallbackComponent={ErrorFallback}
        onReset={() => {
          window.location.reload();
        }}
        onError={(error, info) => {
          // Log error or send it to a tracking service
          console.error("Caught an error:", error, info);
        }}
      >
        <Suspense fallback={<Loader />}>
          {locat.pathname !== "/" &&
          locat.pathname !== "/forgot-password" &&
          !locat.pathname.includes("password-reset") &&
          user ? (
            <Sidebar
              isSidebarOpen={isSidebarOpen}
              setIsSidebarOpen={setIsSidebarOpen}
            />
          ) : null}

          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/password-reset/:token" element={<ResetPassword />} />
            <Route
              path="/dashboard"
              element={user ? <Home /> : <MoveToHome />}
            />
            <Route
              path="/request-site"
              element={user ? <SiteForm /> : <MoveToHome />}
            />
            <Route
              path="/site-details/:type/:id"
              element={user ? <SiteForm /> : <MoveToHome />}
            />
            <Route
              path="/list-sites"
              element={user ? <SitesListing /> : <MoveToHome />}
            />
            <Route
              path="/credentials/:type/:id"
              element={user ? <SiteCredentials /> : <MoveToHome />}
            />
            <Route
              path="/request-site-sign"
              element={user ? <SiteFormSign /> : <MoveToHome />}
            />

            <Route
              path="/add-user"
              element={
                user && user?.role === "admin" ? <AddUsers /> : <MoveToHome />
              }
            />
            <Route
              path="/edit-user/:id"
              element={
                user && user?.role === "admin" ? <EditUsers /> : <MoveToHome />
              }
            />
            <Route
              path="/profile"
              element={user ? <Profile /> : <MoveToHome />}
            />
            <Route
              path="/users"
              element={
                user && user?.role === "admin" ? <ViewUsers /> : <MoveToHome />
              }
            />
            <Route
              path="/files"
              element={
                user && user?.role === "admin" ? <UploadFile /> : <MoveToHome />
              }
            />
            <Route
              path="/edit-file/:id"
              element={
                user && user?.role === "admin" ? <UpdateFile /> : <MoveToHome />
              }
            />
            <Route
              path="/categories"
              element={
                user && user?.role === "admin" ? (
                  <UploadCategories />
                ) : (
                  <MoveToHome />
                )
              }
            />
            <Route
              path="/edit-category/:id"
              element={
                user && user?.role === "admin" ? (
                  <UpdateCategories />
                ) : (
                  <MoveToHome />
                )
              }
            />
            <Route
              path="/files/:id"
              element={user ? <ViewFiles /> : <MoveToHome />}
            />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </ErrorBoundary>

      {locat.pathname.match(/\/{2,}/) ? (
        <div className="white-screen"></div>
      ) : null}
      {isVisible && (
        <button onClick={backToTop} className="to-top-btn">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-arrow-up"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5"
            />
          </svg>
        </button>
      )}
    </>
  );
}
